import { React, useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { auth } from "../utils/firebase";
import ShowFiles from "../Components/ShowFiles";
import LinearProgress from "@mui/material/LinearProgress";
import ChatInput from "../Components/ChatInput";
import ChatMessage from "../Components/ChatMessage";
import { convertToPdf } from "../utils/convertToPdf";
import { saveAs } from "file-saver";
import { gapi } from "gapi-script";
import NavBar from "../Components/NavBar";
import DownwnloadModalOptions from "../Components/DownloadModal";
import eventBus from "../utils/eventBus";
import MainAssistantInstructions from "../Components/MainAssistantInstructions";
import RenderTabPanel from "../Components/RenderTabPanel";
// GENIE HISTORY: Reuse the eligibility UI to show the profile-form conversation.
import GeninieChatPanel from "../Components/GeninieChatPanel";
// LOCAL ELIGIBILITY HISTORY: Rebuild fixed Genie guidance and use the
// proposal-specific browser snapshot when route state is unavailable.
import {
  PROFILE_DETERMINISTIC_CHAT_MESSAGES,
  loadEligibilityChatSnapshot,
} from "../utils/eligibilityChatHistory";


import { convertToDocx } from "../utils/convertToDocx";
import useResizablePanel from "../hooks/useResizablePanel";
import { fetchChatHistory } from "../api/fetchChatHisoty";
import { transformChatData } from "../utils/transformChat";
import { mergeNewMessages } from "../utils/mergeNewMessages";
import { createHandleSubmit } from "../handlers/handleChatSubmit";
import { IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { ApplicationQuestionDisplay } from "../Components/ApplicationQuestionDisplay";

function Main() {
  const [selectedCopilotDocs, setSelectedCopilotDocs] = useState([]);
  const { clientId, grantId } = useParams();
  const baseurl = process.env.REACT_APP_API_URL;
  const SCOPES = "https://www.googleapis.com/auth/drive.file";
  const [pdfData, setpdfData] = useState();
  const [pdfCopilotData, setpdfCopilotData] = useState();
  const [docxData, setDocxData] = useState([]);
  const [docxCopilotData, setDocxCopilotData] = useState([]);
  const [copilotInput, setCopilotInput] = useState("");
  const [chatInput, setChatInput] = useState("");
  const [waitingForResponse, setWaitingForResponse] = useState(false);
  const [isMainChatLoading, setIsMainChatLoading] = useState(false);
  const [isCopilotLoading, setIsCopilotLoading] = useState(false);
  const [sentformData, setSentformData] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [copilotMessages, setCopilotMessages] = useState([]);
  const [uid, setUid] = useState(null);
  const [gptVersion, setGptVersion] = useState("gpt-4o-mini");
      const location = useLocation();
  // GENIE HISTORY: Route state gives the immediate handoff after form save.
  // Direct visits and refreshes load the same proposal's local browser snapshot.
  const routeGrantProfileChat = location.state?.grantProfileChat || null;
  // DIRECT-ROUTE SAFETY: Dashboard/direct navigation has no router snapshot on
  // its first render. Start with an empty object until localStorage is checked.
  const [grantProfileChat, setGrantProfileChat] = useState(
    routeGrantProfileChat || {}
  );
  const [activeGenieChatTab, setActiveGenieChatTab] = useState("eligibility");

  const [uploadedDoc, setUploadedDoc] = useState(null);

  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const { panelWidth, startResizing } = useResizablePanel();
  const navigate = useNavigate();

  const {
    formDetails = {},
    currentClient = {},
    clientID: fallbackCID,
    profileName: stateProfileName,
  } = location.state || {};

    // ROUTE FALLBACKS: The profile form supplies IDs in the URL and route state,
  // while older entry points may still provide formDetails/currentClient.
  const grantProposalForm_id = formDetails.id || grantId;
  const client_Organization_id = currentClient.client_id || fallbackCID || clientId;

  const profileName = stateProfileName || formDetails.Grant_Proposal_Name || "";

  // LOCAL HISTORY FALLBACK: Router state is transient, so load the minimal
  // eligibility snapshot saved for this user/client/proposal after auth resolves.
    useEffect(() => {
    // IMMEDIATE HANDOFF: Prefer the current form navigation snapshot when one
    // exists, rather than retaining history from a previously viewed proposal.
    if (routeGrantProfileChat) {
      setGrantProfileChat(routeGrantProfileChat);
      return;
    }

    if (!uid || !client_Organization_id || !grantProposalForm_id) {
      return;
    }

    const storedSnapshot = loadEligibilityChatSnapshot({
      uid,
      clientId: client_Organization_id,
      grantId: grantProposalForm_id,
    });

    // LOCAL FALLBACK: A missing record is valid for legacy proposals. Keep an
    // empty object so the deterministic messages can still render safely.
    setGrantProfileChat(storedSnapshot || {});
  }, [
    routeGrantProfileChat,
    uid,
    client_Organization_id,
    grantProposalForm_id,
  ]);

  // Auto-scroll + show "scroll-to-bottom" button

  useEffect(() => {
    const chatContainer = chatContainerRef.current;
    const handleScroll = () => {
      if (!chatContainer) return;
      const isAtBottom =
        chatContainer.scrollHeight - chatContainer.scrollTop <=
        chatContainer.clientHeight + 50;
      setShowScrollButton(!isAtBottom);
    };
    const scrollToBottom = () => {
      chatContainer?.scrollTo({ top: chatContainer.scrollHeight, behavior: "smooth" });
    };
    const timer = setTimeout(scrollToBottom, 100);
    chatContainer?.addEventListener("scroll", handleScroll);
    return () => {
      clearTimeout(timer);
      chatContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [messageList]);

  const handleScrollToBottom = () => {
    chatContainerRef.current?.scrollTo({
      top: chatContainerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleScrollToQuestion = (idx) => {
    const chat = chatContainerRef.current;
    const target = document.getElementById(`question-${idx}`);
    if (chat && target) {
      const offset = target.offsetTop - chat.offsetTop;
      chat.scrollTo({ top: offset, behavior: "smooth" });
    }
  };

  const handleSubmit = createHandleSubmit({
    chatInput,
    copilotInput,
    waitingForResponse,
    setWaitingForResponse,
    setIsMainChatLoading,
    setIsCopilotLoading,
    messageList,
    setMessageList,
    setDocxData,
    setpdfData,
    convertToPdf,
    setChatInput,
    setCopilotMessages,
    setCopilotInput,
    uid,
    gptVersion,
    location,
    uploadedDoc,
    baseurl,
    selectedDocs: selectedCopilotDocs,
  });

  const handleCopilotSubmit = () => handleSubmit("copilot");
  const handleMainSubmit = () => handleSubmit("main");
  let questionCounter = 0;

  const [userQuestions, setUserQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mainDisplayMode, setMainDisplayMode] = useState("words");
  const [copilotDisplayMode, setCopilotDisplayMode] = useState("words");
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(0);
  const [activeTab, setActiveTab] = useState("rpfQuestions");

  useEffect(() => {
    const handler = (payload) => setUploadedDoc(payload);
    eventBus.on("file:parsed", handler);
    return () => eventBus.off("file:parsed", handler);
  }, [setUploadedDoc]);

  // Auth gate
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (user) setUid(user.uid);
      else navigate("/login");
    });
    return unsub;
  }, [navigate]);

  // Data boot
  useEffect(() => {
    if (!uid) return;
    populateCopilotResponseAnswers();
    populateChat();
    gapi.load("client:auth2", initClient);
  }, [uid]);

    // DIRECT-ROUTE SAFETY: Only submit the transient form handoff when this
  // page was entered from the form. Old/direct proposal URLs have no form data.
  useEffect(() => {
    if (!uid || sentformData || !location.state?.formData) return;

    sendformData();
    setSentformData(true);
  }, [uid, sentformData, location.state?.formData]);

  const initClient = () => {

    gapi.client
      .init({
        clientId: process.env.REACT_APP_CLIENT_ID_GOOGLE,
        scope: SCOPES,
        discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
        ux_mode: "popup",
      })
      .catch((e) => console.error("Error initializing GAPI client:", e));
  };

  const filteredAnswers = (list) =>
    Array.isArray(list) ? list.filter((q) => q.user === "user") : [];

  const normalizeFileId = (filename) => {
    const stem =
      filename.lastIndexOf(".") > 0
        ? filename.substring(0, filename.lastIndexOf("."))
        : filename;
    return stem.replace(/ /g, "_");
  };

  const handleCopilotDocClick = (doc) => {
    const fileId = normalizeFileId(doc.name);
    setCopilotInput((prev) => `${prev}  `);
    setSelectedCopilotDocs((prev) => (prev.includes(fileId) ? prev : [...prev, fileId]));
  };

  const authenticate = async () => {
    try {
      const user = await gapi.auth2.getAuthInstance().signIn({ scope: SCOPES });
      return user;
    } catch (e) {
      console.error("Authentication error:", e);
    }
  };

  const handleGptVersionChange = (v) => setGptVersion(v);
  const handleTabChange = (tab) => setActiveTab(tab);
  const handleRefreshPdf = (updated) => setpdfData(convertToPdf(updated));
  function clearChat() { setMessageList([]); }

  async function populateCopilotResponseAnswers() {
    try {
      const response = await fetch(`${baseurl}/copilot-response-answers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: uid || localStorage.getItem("user_id"),
          client_organization_id: clientId,
          grant_proposal_form_id: grantId,
        }),
      });
      const data = await response.json();

      const transformed = [];
      data.map((item, index) => {
        if (item.question) {
          transformed.push({
            user: "user",
            message: item.question,
            id: item.id || `${Date.now()}-${index}`,
          });
        }
        if (item.answer) {
          transformed.push({
            user: "bot",
            message: item.answer,
            question: item.question,
            timestamp: item.timestamp,
          });
        }
      });

      setDocxCopilotData(transformed);
      setpdfCopilotData(convertToPdf(transformed));
      setCopilotMessages((prev) => {
        const newOnes = transformed.filter(
          (n) => !prev.some((p) => p.user === n.user && p.message === n.message)
        );
        return [...prev, ...newOnes];
      });

      const updatedUserQuestions = copilotMessages
        .filter((m) => m.user === "user")
        .map((m) => ({ ...m, uid }));
      setUserQuestions(...updatedUserQuestions);
    } catch (e) {
      console.log("error fetching chats:", e.message);
    }
  }

  async function populateChat() {
    try {
      const data = await fetchChatHistory({ baseurl, uid, clientId, grantId });
      const transformedData = transformChatData(data);
      setDocxData(transformedData);
      setpdfData(convertToPdf(transformedData));
      setMessageList((prev) => mergeNewMessages(prev, transformedData));
      const updatedUserQuestions = transformedData
        .filter((m) => m.user === "user")
        .map((m) => ({ ...m, uid }));
      setUserQuestions(updatedUserQuestions);
    } catch (e) {
      console.log("error fetching chats:", e.message);
    }
  }

  async function sendformData() {
    setWaitingForResponse(true);
    setIsLoading(true);
    await fetch(`${baseurl}/gptRun/form`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user: uid, currentForm: location.state?.formData }),

    });
    setWaitingForResponse(false);
    setIsLoading(false);
  }

  function handleRefreshClick() {
    console.log("Clicked outer refresh");
  }

  return (
    <>
      <NavBar />

      {/* FIXED header row under the nav bar (assume ~48px nav height) */}
      <div className="fixed left-0 right-0 z-30" style={{ top: "48px" }}>
        <div className="px-6 py-2">
          <div className="flex items-center justify-between gap-4">
            <div className="text-white font-semibold text-lg md:text-2xl truncate pl-4">
              {profileName}
            </div>
            <div className="flex items-center gap-2">
              <ShowFiles
                uid={uid}
                grantProposalForm_id={grantProposalForm_id}
                client_Organization_id={client_Organization_id}
                selectedDocs={selectedCopilotDocs}
                setSelectedDocs={setSelectedCopilotDocs}
                className="w-auto ml-0 mr-0 mt-0"
              />
              <DownwnloadModalOptions
                id="downloadModalOptions"
                pdfData={pdfData}
                pdfProfileName={profileName}
                docx={() =>
                  convertToDocx(
                    docxData,
                    true,
                    profileName,
                    gapi,
                    authenticate,
                    saveAs
                  )
                }
                drive={() =>
                  convertToDocx(
                    docxData,
                    true,
                    profileName,
                    gapi,
                    authenticate,
                    saveAs
                  )
                }
                disabled={!docxData || docxData.length === 0}
                className="w-auto ml-0 mr-0 mt-0"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Give the page enough top padding so panels don't slide under the fixed header */}
      <div className="pt-[88px] flex flex-col">
        <div className="dash-2 left-0 right-0 flex flex-col">
          <div
            className="panels flex flex-2 overflow-hidden px-6 mt-0 space-x-6"
            style={{ height: "calc(100vh - 75px)" }}
          >
            {/* Left panel */}
            <div
              className="side-panel bg-[#11002e] border-[#5406D2] flex flex-col relative"
              style={{ width: `${panelWidth}px`, minWidth: "400px" }}
            >
              <div
                onMouseDown={startResizing}
                className="absolute right-0 top-0 h-full w-[5px] cursor-ew-resize"
                style={{ width: "20px", backgroundColor: "transparent", zIndex: 9999 }}
              />
                            {/*
                LEGACY LEFT PANEL (preserved): The former Copilot/content panel
                remains here as reference, but Genie history is now rendered below.
                <RenderTabPanel
                  onSelectQuestion={handleScrollToQuestion}
                  activeTab={activeTab}
                  handleTabChange={handleTabChange}
                  uid={uid}
                  filteredAnswers={filteredAnswers}
                  messageList={messageList}
                  copilotMessages={copilotMessages}
                  isLoading={isLoading}
                  displayMode={copilotDisplayMode}
                  handleDisplayModeChange={setCopilotDisplayMode}
                  wordCount={wordCount}
                  charCount={charCount}
                  selectedCopilotDocs={selectedCopilotDocs}
                  setDocxCopilotData={setDocxCopilotData}
                  docxCopilotData={docxCopilotData}
                  location={location}
                  isCopilotLoading={isCopilotLoading}
                  copilotInput={copilotInput}
                  setCopilotInput={setCopilotInput}
                  handleCopilotSubmit={handleCopilotSubmit}
                  uploadedDoc={uploadedDoc}
                  handleCopilotDocClick={handleCopilotDocClick}
                  handleGptVersionChange={handleGptVersionChange}
                  setSelectedCopilotDocs={setSelectedCopilotDocs}
                  onRefreshPdf={handleRefreshPdf}
                />
              */}

              {/* NEW LEFT PANEL: Completed eligibility conversation from the form. */}
              <GeninieChatPanel
                activeChatTab={activeGenieChatTab}
                onActiveChatTabChange={setActiveGenieChatTab}
                currentStep={4}
                showHeading 
                headingText={"\u00A0"}
                hasConfirmedGrantInfo={Boolean(
                  grantProfileChat?.hasConfirmedGrantInfo ||
                  grantProfileChat?.eligibilityResult ||
                  grantProfileChat?.eligibilityError
                )}
                grantUrl={grantProfileChat?.grantUrl}
                eligibilityLoading={false}
                eligibilityError={grantProfileChat?.eligibilityError || null}
                eligibilityResult={grantProfileChat?.eligibilityResult || null}
                clarifications={grantProfileChat?.clarifications || {}}
                proposalPromptAnswer={grantProfileChat?.proposalPromptAnswer ?? null}
                                // RECONSTRUCTED HISTORY: Fixed onboarding/form guidance is
                // identical across proposals; only the eligibility snapshot varies.
                chatMessages={PROFILE_DETERMINISTIC_CHAT_MESSAGES}

                isTyping={false}
                readOnly
              />

            </div>

            {/* Scroll-to-bottom button (floats on right) */}
            {showScrollButton && (
              <div className="absolute bottom-[200px] right-8 z-10">
                <IconButton
                  onClick={handleScrollToBottom}
                  sx={{
                    backgroundColor: "#5406D2",
                    color: "white",
                    "&:hover": { backgroundColor: "#400080" },
                  }}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
              </div>
            )}

            {/* Right chat panel */}
            <div className="chatbox flex-1 flex flex-col h-full relative rounded-lg mt-10">
              {/* --- START OF NEW APPLICATION QUESTION DISPLAY UI --- */}
              <ApplicationQuestionDisplay 
                  grantID={grantId} 
                  uid={uid} 
                  clientID={client_Organization_id} 
              />
              {/* --- END OF NEW APPLICATION QUESTION DISPLAY UI --- */}


              {/* Code for OLD chat panel */}
              {/* <div
                ref={chatContainerRef}
                className="flex-1 overflow-y-auto custom-scrollbar scroll-pt-[85px] pb-[25px]"
              >
                {messageList.map((message, index) => {
                  const questionIndex = message.user === "user" ? questionCounter++ : null;
                  return (
                    <div
                      key={message.id || index}
                      id={message.user === "user" ? `question-${questionIndex}` : undefined}
                    >
                      <ChatMessage
                        message={{ ...message, questionIndex }}
                        parentRefreshClick={handleRefreshClick}
                        isLoading={isLoading}
                        displayMode={mainDisplayMode}
                        handleDisplayModeChange={setMainDisplayMode}
                        wordCount={wordCount}
                        charCount={charCount}
                        showCount
                        user_id={uid}
                        client_organization_id={
                          location.state?.currentClient?.client_id || location.state.clientID
                        }
                        grant_proposal_form_id={
                          location.state?.formDetails?.id || location.state.grantProposalForm_id
                        }
                        onRefreshPdf={handleRefreshPdf}
                        docxData={docxData}
                        setDocxData={setDocxData}
                        convertToDocx={convertToDocx}
                        convertToPdf={convertToPdf}
                      />
                    </div>
                  );
                })}
                {messageList.length === 0 && <MainAssistantInstructions />}
                {isMainChatLoading && (
                  <LinearProgress
                    color="secondary"
                    sx={{ width: "100%", position: "relative", zIndex: 9999, mb: 1 }}
                  />
                )}
                <div
                  ref={messagesEndRef}
                  style={{ float: "left", clear: "both", height: "1px" }}
                />
              </div> */}

              {/* Footer input */}
              {/* <div className="flex-none sticky bottom-0 bg-[#11002E] p-4 z-20">
                <div className="w-full">
                  <ChatInput
                    from={"main"}
                    location={location}
                    style={{ width: "100%" }}
                    client_Organization_id={
                      location?.state?.currentClient?.client_id || location.state.clientID
                    }
                    grant_proposal_form_id={
                      location?.state?.formDetails?.id || location.state.grantProposalForm_id
                    }
                    uid={uid}
                    input={chatInput}
                    setInput={setChatInput}
                    handleSubmit={handleMainSubmit}
                    isLoading={isLoading}
                    handleDisplayModeChange={setMainDisplayMode}
                    displayMode={mainDisplayMode}
                    wordCount={wordCount}
                    charCount={charCount}
                    handleGptVersionChange={handleGptVersionChange}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Main;
